import { Omit, Partial } from '@40seas/entities/common';
import { BaseEntityFieldsArray } from '@40seas/models';
import { FinancialConnection } from './financial-connection.entity';

export class UpdateFinancialConnectionDto extends Partial(Omit(FinancialConnection, [...BaseEntityFieldsArray])) {}
